/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import ArticlePage from 'flarum/orell-articles/components/ArticlePage';
import ArticlePageReviews from '../components/ArticlePageReviews';

export default function () {
	extend(ArticlePage.prototype, 'items', function (items) {
		const { article } = this;

		if (!article) {
			return;
		}

		items.add('reviews', <ArticlePageReviews article={article} />, 50);
	});
}
